import {
  HTTPError,
  checkRequestPossibility,
  processErrorCodes,
  getHeaders,
} from '@jetbrains/teamcity-ui/dist/services'
import type {RestRequestOptions} from '@jetbrains/teamcity-ui/dist/services'
import oboe from 'oboe'

export default function stream<T, N>(
  url: string,
  pattern: string,
  onProgress: (n: N) => unknown,
  options?: RestRequestOptions,
): Promise<T> {
  return new Promise((resolve, reject) => {
    try {
      checkRequestPossibility()
    } catch (error) {
      reject(error)
    }

    function request(isRetry = false) {
      const headers = getHeaders(options)
      const csrfToken = headers['X-TC-CSRF-Token']
      oboe({
        url,
        headers,
        withCredentials: true,
      })
        .node(pattern, onProgress)
        .done(resolve)
        .fail(async ({thrown, statusCode, body}) => {
          const shouldRetry =
            !isRetry &&
            (await processErrorCodes({
              url,
              statusCode,
              getMessage: () => body ?? '',
              retryCallback: () => request(true),
              csrfToken,
            }))

          if (!shouldRetry) {
            reject(
              thrown ??
                new HTTPError(
                  body || `Network Error when loading builds, status code is ${statusCode}`,
                  statusCode,
                  url,
                ),
            )
          }
        })
    }

    request()
  })
}
